var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, flow, observable } from "mobx";
import { DisplayMode } from "../constants/DisplayMode.enum";
import { addToArrayIfNew, removeFromArray } from "../utils/array.utils";
import { breakpoint } from "../utils/breakpoints.utils";
import { makeDialogController } from "./dialog.controller";
import { makeOverlayController } from "./overlay.controller";
import { makePortalController } from "./portal.controller";
export var makeUIController = function () {
    var c = observable({
        $root: null,
        vw: window.innerWidth,
        vh: window.innerHeight,
        get viewportRatio() {
            return c.vw / c.vh;
        },
        get displayMode() {
            if (c.vw >= breakpoint('desktop'))
                return DisplayMode.desktop;
            if (c.vw >= breakpoint('tablet'))
                return DisplayMode.tablet;
            return DisplayMode.phone;
        },
        cssFeatures: {
            // grid: false,
            // customProperties: false,
            grid: window.CSS && window.CSS.supports('display', 'grid'),
            customProperties: window.CSS && window.CSS.supports('color', 'var(--c)')
        },
        get onlySmallPhones() {
            return c.vw <= 375 && c.vh < 575;
        },
        get onlyPhones() { return c.displayMode === 'phone'; },
        get fromTablet() { return c.displayMode !== 'phone'; },
        get fromTabletMd() { return c.vw >= breakpoint('tablet-md'); },
        get fromTabletLg() { return c.vw >= breakpoint('tablet-lg'); },
        get uptoTabletLg() { return c.vw < breakpoint('tablet-lg'); },
        get onlyTablets() { return c.displayMode === 'tablet'; },
        get uptoDesktop() { return c.vw < breakpoint('desktop'); },
        get fromDesktop() { return c.displayMode === 'desktop'; },
        get fromDesktopMd() { return c.vw >= breakpoint('desktop-md'); },
        get fromDesktopLg() { return c.vw >= breakpoint('desktop-lg'); },
        get fromTabletAndTall() { return c.fromTablet && c.vh >= 625; },
        DIALOG: makeDialogController(),
        PORTAL: makePortalController(),
        OVERLAY: makeOverlayController(),
        portalFocusableElementStack: [],
        focusOnElementInPortal: action(function (el) {
            if (!el)
                return;
            removeFromArray(c.portalFocusableElementStack, el);
            addToArrayIfNew(c.portalFocusableElementStack, el);
        }),
        $init: flow(function (root) {
            return __generator(this, function (_a) {
                c.$root = root;
                return [2 /*return*/];
            });
        }),
        $reset: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); },
    });
    var measureViewport = action(function () {
        c.vw = window.innerWidth;
        c.vh = window.innerHeight;
    });
    var html = document.documentElement;
    window.addEventListener('resize', measureViewport);
    if (!c.cssFeatures.grid)
        html.classList.add('nogrid');
    if (!c.cssFeatures.customProperties) {
        html.classList.add('novar');
    }
    return c;
};
